import type { OrganizationBase } from 'models';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { findStateByCode } from 'common/utils';
import { OrganizationOption } from '../organization-option';
import type { PrimaryOrganizationOption } from '../PrimaryOrganizationSelect';

export const useCreatePrimaryOrganizationOption = () => {
  const { t } = useTranslation();
  const { t: translationState } = useTranslation('translationStates');

  return useCallback(
    (organization: OrganizationBase): PrimaryOrganizationOption => ({
      label: organization.name,
      optionLabel: (
        <OrganizationOption
          description={[organization.city, translationState(findStateByCode(organization.state)?.translationKey ?? '')]
            .filter(Boolean)
            .join(', ')}
          image={{
            alt: t('{{organizationName}} photo', { organizationName: organization.name }),
            src: organization.squareLogo?.url ?? organization.profilePhoto?.url,
          }}
          title={organization.name}
        />
      ),
      value: organization.id,
    }),
    [t, translationState],
  );
};
